module.exports = __webpack_public_path__ + "img/20191121180039_4569.81719221.jpg";